import React from "react";
import "./Button.scss";

type ButtonProps = {
    children: React.ReactNode;
    href?: string;
    type?: "button" | "submit";
    variant?: "primary" | "secondary";
    onClick?: () => void;
    className?: string;
    disabled?: boolean;
};

export function Button({
                           children,
                           href,
                           type = "button",
                           variant = "primary",
                           onClick,
                           className = "",
                           disabled = false,
                       }: ButtonProps) {
    const classes = ["button", "button--" + variant, className].filter(Boolean).join(" ");
    const content = (
        <>
            <span>{children}</span>
            <span className="button__arrow" aria-hidden="true">↗</span>
        </>
    );

    if (href) {
        return <a className={classes} href={href} onClick={onClick}>{content}</a>;
    }

    return <button className={classes} type={type} onClick={onClick} disabled={disabled}>{content}</button>;
}
